/**
 * Géométrie de page — SOURCE UNIQUE des constantes d'impression.
 *
 * Historiquement, EvalPrintPage et packBlocks portaient chacun leur jeu de
 * constantes (HEADER_OVERHEAD=80, STUDENT_FIELDS_HEIGHT=70, SAFETY_BUFFER=20
 * d'un côté ; PAGE_SAFETY_BUFFER=68, MASTHEAD_EVAL=70 de l'autre) — devinées,
 * divergentes, et responsables de ~100 px perdus par page (pages sous-remplies)
 * ou d'overflows (pages A4 quasi vides à cause du break-inside: avoid).
 *
 * Désormais : SEULE la hauteur utile A4 est une constante (dérivée de @page).
 * Tout le chrome (CompactHeader, StudentFields, padding/margin de .ep-page)
 * est MESURÉ au pixel dans la phase mesure d'EvalPrintPage — comme les
 * sections elles-mêmes. La marge de sécurité tombe à quelques px (sub-pixel
 * + variance du moteur PDF).
 */

/** Hauteur utile d'une page A4 en px @96dpi après @page { margin: 6mm 14mm 12mm }
 *  (297 − 6 − 12 = 279mm × 3.7795 ≈ 1054). Doit rester synchronisée avec
 *  eval-print.css — la marge haute a été réduite à 6mm pour que l'en-tête de
 *  page loge DANS l'ancienne bande de marge au lieu de s'y ajouter. */
export const USABLE_PAGE_HEIGHT = 1054;

/** Espace vertical entre sections dans une page (cf. .ep-page > * margin-bottom). */
export const SECTION_GAP = 16;

/**
 * Marge de sécurité résiduelle : arrondis sub-pixel + VARIANCE DU MOTEUR
 * D'IMPRESSION — les hauteurs rendues en PDF diffèrent de quelques px de la
 * mesure écran (fonts rasterisées autrement, arrondis d'images). À 6 px, une
 * page remplie « pile » à la mesure pouvait déborder de 1-10 px au print →
 * break-inside: avoid basculait la page entière → page A4 quasi vide
 * (constaté sur une éval gen_674 : SVG pavés + QCM choix-images). 16 px
 * (~1,5 % de la page) absorbe cette variance sans sous-remplissage visible.
 */
export const SAFETY = 16;

/** Valeurs de repli si une sonde de mesure venait à manquer (jamais en usage
 *  normal — uniquement du défensif, alignées sur les anciennes estimations). */
export const FALLBACK_CHROME_H = 80;
export const FALLBACK_STUDENT_H = 70;
